import { defineFileAction, ChonkyIconName, ChonkyActions } from "chonky";

// const uploadFileAction = defineFileAction({
//   id: "upload",
//   fileFilter: (file) => file.isDir,
//   button: {
//     name: "Upload",
//     toolbar: true,
//     contextMenu: true,
//     icon: ChonkyIconName.upload,
//   },
// });

// const delegateFileAction = defineFileAction({
//   id: "delegate",
//   fileFilter: (file) => file.isDir,
//   button: {
//     name: "Delegate",
//     toolbar: true,
//     contextMenu: true,
//     icon: ChonkyIconName.loading,
//   },
// });

const viewFileAction = defineFileAction({
  id: "view",
  requiresSelection: true,
  fileFilter: (file) => file && !file.isDir,
  button: {
    name: "Xem",
    toolbar: true,
    contextMenu: true,
    icon: ChonkyIconName.search,
  },
});

const selectFileAction = defineFileAction({
  id: "select",
  requiresSelection: true,
  fileFilter: (file) => file && !file.isDir,
  button: {
    name: "Chọn",
    toolbar: true,
    contextMenu: true,
    icon: ChonkyIconName.image ,
  },
});

const createNewFolder = defineFileAction({
  id: "create_files",
  button: {
    name: "Thư mục mới",
    toolbar: true,
    contextMenu: true,
    icon: ChonkyIconName.folderCreate,
  },
});

const editFiles = defineFileAction({
  id: "edit_files",
  button: {
    name: "Chỉnh sửa",
    toolbar: true,
    contextMenu: true,
    icon: ChonkyIconName.archive,
  },
});

const renameFiles = defineFileAction({
  id: "rename_files",
  button: {
    name: "Đổi tên",
    toolbar: true,
    contextMenu: true,
    icon: ChonkyIconName.code,
  },
});

const removeFiles = defineFileAction({
  id: "remove_files",
  hotkeys: ["delete"],
  button: {
    name: "Xóa",
    toolbar: true,
    contextMenu: true,
    icon: ChonkyIconName.trash,
  },
});

export const customActions = [
  selectFileAction,
  viewFileAction,
  ChonkyActions.UploadFiles,
  // delegateFileAction,
  // uploadFileAction,
  createNewFolder,
  // editFiles,
  renameFiles,
  removeFiles,
  // ChonkyActions.DeleteFiles,
];
